import React, {FC, ReactNode} from 'react';
import TrCustom from "@ui/tableCustom/view/ui/trCustom/TrCustom";

interface IProps{
    hasTr?:boolean,
    children:ReactNode,
}

const CurrentTr:FC<IProps> = ({hasTr,children}) => {

    if(hasTr){
        return (
            <TrCustom>
                {children}
            </TrCustom>
        )
    }
    return (
        <>
            {children}
        </>
    );
};

export default CurrentTr;